<div class="search-window" [formGroup]="form">
  <div class="item top" matAutocompleteOrigin #profOrigin="matAutocompleteOrigin">
    @if (isBar) {
      <icon class="field-icon field-icon--search" name="search" aria-hidden="true"></icon>
    }
    <div class="item-header">Zoekterm</div>
    @if (!isMobile) {
      <mat-form-field class="profession" appearance="fill" >
        <input
          type="search"
          matInput
          [placeholder]="professionPlaceholder"
          aria-label="Functie"
          formControlName="profession"
          [matAutocomplete]="auto1"
          [matAutocompleteConnectedTo]="$any(isBar ? profOrigin : null)"
          #profTrigger="matAutocompleteTrigger"
          inputmode="search"
          enterkeyhint="search"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          (keydown.enter)="onKeyEnter($event, profTrigger)"
          />
        @if (form.get('profession')?.value) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="clear-button"
            (click)="onClear($event, 'profession')"
            aria-label="Wissen"
            >
            <span class="visually-hidden">Wissen</span>
            <icon name="close"></icon>
          </button>
        }
        <mat-autocomplete
          #auto1="matAutocomplete"
          [class]="suggestionPanelClass"
          (optionSelected)="onSubmit()"
          >
          @if (isBar) {
            @for (group of professionGroups$ | async; track group.label) {
              <mat-optgroup [label]="group.label">
                @for (option of group.options; track option.value) {
                  <mat-option [value]="option.value">
                    <span class="suggestion" [innerHTML]="highlightMatch(option.value, 'profession')"></span>
                    <span class="suggestion-count">{{ option.count }}<span class="visually-hidden"> {{ option.count === 1 ? 'vacature' : 'vacatures' }}</span></span>
                  </mat-option>
                }
              </mat-optgroup>
            }
          } @else {
          @for (option of professionOptions$ | async; track option) {
            <mat-option
              [value]="option"
            (touchend)="
              onOptionTouch(option, 'profession', profTrigger, $event)
            "
              >
              <span
                class="suggestion"
                [innerHTML]="highlightMatch(option, 'profession')"
              ></span>
            </mat-option>
          }
          }
        </mat-autocomplete>
      </mat-form-field>
    } @else {
      <mat-form-field class="profession" appearance="fill" >
        <input
          type="search"
          matInput
          [placeholder]="professionPlaceholder"
          aria-label="Functie"
          formControlName="profession"
          inputmode="search"
          enterkeyhint="search"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          (focus)="onFocus('profession')"
          (keydown.enter)="onKeyEnter($event)"
          />
        @if (form.get('profession')?.value) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="clear-button"
            (click)="onClear($event, 'profession')"
            aria-label="Wissen"
            >
            <span class="visually-hidden">Wissen</span>
            <icon name="close"></icon>
          </button>
        }
      </mat-form-field>
    }
  </div>
  <div class="item left" matAutocompleteOrigin #locOrigin="matAutocompleteOrigin">
    @if (isBar) {
      <icon class="field-icon" name="location_on" aria-hidden="true"></icon>
    }
    <div class="item-header">Locatie</div>
    @if (!isMobile) {
      <mat-form-field class="location" appearance="fill" >
        <input
          type="search"
          matInput
          placeholder="Stad of provincie"
          aria-label="Stad of provincie"
          formControlName="location"
          [matAutocomplete]="auto"
          [matAutocompleteConnectedTo]="$any(isBar ? locOrigin : null)"
          #locTrigger="matAutocompleteTrigger"
          inputmode="search"
          enterkeyhint="search"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          (keydown.enter)="onKeyEnter($event, locTrigger)"
          />
        @if (form.get('location')?.value) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="clear-button"
            (click)="onClear($event, 'location')"
            aria-label="Wissen"
            >
            <span class="visually-hidden">Wissen</span>
            <icon name="close"></icon>
          </button>
        }
        <mat-autocomplete #auto="matAutocomplete" [class]="suggestionPanelClass" (optionSelected)="onSubmit()">
          @if (isBar) {
            @for (group of locationGroups$ | async; track group.label) {
              <mat-optgroup [label]="group.label">
                @for (option of group.options; track option.value) {
                  <mat-option [value]="option.value">
                    <span class="suggestion" [innerHTML]="highlightMatch(option.value, 'location')"></span>
                    <span class="suggestion-count">{{ option.count }}<span class="visually-hidden"> {{ option.count === 1 ? 'vacature' : 'vacatures' }}</span></span>
                  </mat-option>
                }
              </mat-optgroup>
            }
          } @else {
          @for (option of locationOptions$ | async; track option) {
            <mat-option
              [value]="option"
              (touchend)="onOptionTouch(option, 'location', locTrigger, $event)"
              >
              <span
                class="suggestion"
                [innerHTML]="highlightMatch(option, 'location')"
              ></span>
            </mat-option>
          }
          }
        </mat-autocomplete>
      </mat-form-field>
    } @else {
      <mat-form-field class="location" appearance="fill" >
        <input
          type="search"
          matInput
          placeholder="Stad of provincie"
          aria-label="Stad of provincie"
          formControlName="location"
          inputmode="search"
          enterkeyhint="search"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          (focus)="onFocus('location')"
          (keydown.enter)="onKeyEnter($event)"
          />
        @if (form.get('location')?.value) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="clear-button"
            (click)="onClear($event, 'location')"
            aria-label="Wissen"
            >
            <span class="visually-hidden">Wissen</span>
            <icon name="close"></icon>
          </button>
        }
      </mat-form-field>
    }
  </div>
  <div class="item bottom">
    <div class="item-header"></div>
    <button
      type="button"
      class="apple-cta apple-cta--blue"
      (click)="onSubmit()"
      >
      <span>Zoeken</span>
      @if (isBar) {
        <svg class="cta-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.5 12h15M13.5 6l6 6-6 6" /></svg>
      } @else {
        <icon name="search"></icon>
      }
    </button>
  </div>
</div>

<ng-template #mobileOverlay>
  <div
    class="mobile-search-overlay"
    [formGroup]="form"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="overlayPlaceholder"
    (keydown.escape)="onOverlayClose()"
    >
    <div class="overlay-header">
      <button class="overlay-back" type="button" (click)="onOverlayClose()" aria-label="Terug">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" /></svg>
      </button>
      <div class="overlay-field">
        <icon class="overlay-icon" [name]="activeControl === 'location' ? 'location_on' : 'search'" aria-hidden="true"></icon>
        <input
          #overlayInput
          class="overlay-field__input"
          type="search"
          [placeholder]="overlayPlaceholder"
          [attr.aria-label]="overlayPlaceholder"
          [formControlName]="activeControl"
          inputmode="search"
          enterkeyhint="search"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          (keydown.enter)="onOverlaySearch()"
          />
        @if (overlayQuery) {
          <button class="overlay-field__clear" type="button" (click)="onClear($event, activeControl!)" aria-label="Wissen">
            <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
              <circle cx="10" cy="10" r="9" fill="#c7c7cc" />
              <path d="M7 7l6 6M13 7l-6 6" stroke="#fff" stroke-width="1.8" stroke-linecap="round" />
            </svg>
          </button>
        }
      </div>
    </div>
    <div class="overlay-body">
      @if (overlayQuery) {
        <button class="overlay-option overlay-option--query" type="button" (click)="onOverlaySearch()">
          <icon class="overlay-icon overlay-icon--accent" name="search" aria-hidden="true"></icon>
          <span class="suggestion">{{ activeControl === 'location' ? 'Zoek in' : 'Zoek op' }} “{{ overlayQuery }}”</span>
        </button>
      }
      @if (isBar) {
        @for (group of (activeControl === 'profession' ? professionGroups$ : locationGroups$) | async; track group.label) {
          <div class="overlay-suggestions-header">{{ group.label }}</div>
          <div class="overlay-suggestions">
            @for (option of group.options; track option.value) {
              <button class="overlay-option" type="button" (click)="onOverlayOptionClick(option.value)">
                <icon class="overlay-icon" [name]="activeControl === 'profession' ? 'search' : 'location_on'" aria-hidden="true"></icon>
                <span class="suggestion" [innerHTML]="highlightMatch(option.value, activeControl!)"></span>
                <span class="overlay-count">{{ option.count }}<span class="visually-hidden"> {{ option.count === 1 ? 'vacature' : 'vacatures' }}</span></span>
              </button>
            }
          </div>
        }
      } @else {
        <div class="overlay-suggestions-header">Zoeksuggesties</div>
        <div class="overlay-suggestions">
          @for (option of (activeControl === 'profession' ? professionOptions$ : locationOptions$) | async; track option) {
            <button class="overlay-option" type="button" (click)="onOverlayOptionClick(option)">
              <icon class="overlay-icon" [name]="activeControl === 'profession' ? 'search' : 'location_on'" aria-hidden="true"></icon>
              <span class="suggestion" [innerHTML]="highlightMatch(option, activeControl!)"></span>
            </button>
          }
        </div>
      }
    </div>
  </div>
</ng-template>
